import axios from 'axios';
import { clearAuth } from '../utils/auth';

function getLoginPath() {
  return '/login';
}

const apiClient = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Обрабатываем ошибки авторизации
    if (error.response?.status === 401) {
      // 401 всегда означает проблему с авторизацией
      console.warn('Требуется авторизация, перенаправление на страницу логина');
      clearAuth();
      const loginPath = getLoginPath();
      if (window.location.pathname !== loginPath) {
        setTimeout(() => {
          window.location.href = loginPath;
        }, 100);
      }
      return Promise.reject(error);
    }
    
    if (error.response?.status === 403) {
      const message = (error.response?.data?.message || '').toLowerCase();
      // Проверяем различные варианты сообщений об ошибке авторизации
      const isAuthError = 
        message.includes('токен') || 
        message.includes('авторизация') ||
        message.includes('authorization') ||
        message.includes('token') ||
        message.includes('expired') ||
        message.includes('jwt') ||
        message.includes('неверный') ||
        message.includes('просрочен');
      
      if (isAuthError) {
        console.warn('Токен недействителен, перенаправление на страницу логина');
        clearAuth();
        const loginPath = getLoginPath();
        if (window.location.pathname !== loginPath) {
          setTimeout(() => {
            window.location.href = loginPath;
          }, 100);
        }
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
